import App from '../App';

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate, useLocation } from 'react-router-dom';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';

import StringsOfLanguage from '../Localization';
import { ReactSession } from 'react-client-session';


const LoupeGdprWrapper = props => {

    ReactSession.setStoreType("localStorage");
    
    const localizer = StringsOfLanguage;  
    localizer.setLanguage( localizer.getInterfaceLanguage() );
    
    
    const handleLanguageChange = key => {   
        localizer.setLanguage(key);                        
    }
    
    const getAppLanguage = () => {
        return(localizer.getLanguage());
    }
    const getAppInterfaceLanguage = () => {
        return(localizer.getInterfaceLanguage());
    }
    
    const [ isCookieApproved, setIsCookieApproved ] = useState(false);
    const handleCookieApproval = (event) => {
        setIsCookieApproved(event.target.checked);
    };
    const [ isServicesApproved, setIsServicesApproved ] = useState(false);
    const handleServicesApproval = (event) => {
        setIsServicesApproved(event.target.checked);
    };

    const openDataProtectionInformation = () => {        
        var uri = process.env.REACT_APP_BASE_URI + "/" + localizer.getLanguage() + "_" + process.env.REACT_APP_GDPR_FILENAME_SUFFIX; 
        window.open(uri);
      }


    const languageContextValue = {
        strings : localizer,
        setLanguage : handleLanguageChange,
        getLanguage : getAppLanguage,
        getInterfaceLanguage : getAppInterfaceLanguage,
    }

    const location = useLocation();
    const navigate = useNavigate();    

    var prevConsented;

    if( ReactSession.get("hasCookieConsent") === undefined ) {
        
        if(location.state !== null )
        {
            if(location.state.consented !== null)
            {
                prevConsented = location.state.consented;            
            }
            else
            {
                prevConsented = false;
            }

        }
        else
        {
            prevConsented = false;
        }

    } else {

        var prevVal = ReactSession.get("hasCookieConsent");
        if( prevVal == "ok" )
        {
            prevConsented = true;
        }
        else 
        {
            prevConsented = false;
        }
    }
    
    // enable the following line for debugging of gdpr wrapper
    // prevConsented = false;

   
    const [ isConsent, setIsConsent ] = useState(prevConsented);


    const AcceptCookies = () => {
        setIsConsent(true);
        ReactSession.set("hasCookieConsent", "ok");     
    }

    return (

        <LocalizationContext.Provider value={languageContextValue}>
            <LocalizationContext.Consumer>

            { ({strings, setLanguage}) =>  
                <React.Fragment>

                    
                    { isConsent == true &&                 
                        <React.Fragment>
                            <App />
                        </React.Fragment>                
                    }

                    { isConsent == false && 
                    
                        <React.Fragment >
                            

                            <div style={{padding: '50px'}}>
                                <h1 style={{textAlign:'center'}}>{process.env.REACT_APP_CAMPAIGN_NAME}</h1>
                                <p />
                                <h2 style={{textAlign:'center'}}>{strings.getString("texts.titles.help")}</h2>
                                <p />
                                <p>{strings.getString("cookies.texts.introduction")}</p>
                                <p /> 
                                <h5>{strings.getString("cookies.titles.strictlynecessary")}</h5>
                                <p>{strings.getString("cookies.texts.strictlynecessary")}</p>
                                <p />
                                <h5>{strings.getString("cookies.titles.functional")}</h5>
                                <p>{strings.getString("cookies.texts.functional")}</p>
                                <p />
                                <h5>{strings.getString("cookies.titles.statistics")}</h5>
                                <p>{strings.getString("cookies.texts.statistics")}</p>
                                <p />
                                <h5>{strings.getString("cookies.titles.marketing")}</h5>
                                <p>{strings.getString("cookies.texts.marketing")}</p>
                                <p />
                                <h5>{strings.getString("cookies.titles.thirdparty")}</h5>
                                <p>{strings.getString("cookies.texts.thirdparty")}</p>
                                
                                <p className="mb-6"/>  
                                <Button fullWidth={false} onClick={() => openDataProtectionInformation() }>{strings.getString("texts.titles.privacy")}</Button>
                                <p className="mb-6"/>  

                            
                                <Switch
                                    checked={isCookieApproved}
                                    onChange={handleCookieApproval}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <span>{strings.getString("cookies.controls.accept_cookie")}</span>
                                <br />

                                <Switch
                                    checked={isServicesApproved}
                                    onChange={handleServicesApproval}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                <span>{strings.getString("cookies.controls.accept_third")}</span>
                                <p />

                                { isCookieApproved && isServicesApproved && 
                                    <Button onClick={() => AcceptCookies()}>{strings.getString("controls.buttons.continue")}</Button>
                                }
                            </div>
                        </React.Fragment>
                    }




                </React.Fragment>
            }
            </LocalizationContext.Consumer>
        </LocalizationContext.Provider>

    );


}

export const LocalizationContext = new React.createContext(
    { 
      strings : null, 
      setLanguage : (key) => {}, 
      getLanguage : () => {},
      getInterfaceLanguage : () => {}, 
    }
  );

export default LoupeGdprWrapper;